import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { _post, _Alert } from './Function';
import Loading from './Loading';
import '../css/Register.css';

class RegisterOTP extends Component {
    constructor(props) {
        super(props);
        this.state={ page: this.props.Page, timeOut: '00:00', otp: '', loadingShow: false };
        setTimeout(()=>{
            this.timeCount(this.props.timeOut);
        }, 100)
    }

    update = (t, e) => {
        this.setState({ [t]: e.target.value });
    }

    timeCount(time) {
        var countDownDate = new Date(time);
        this.timeOut = setInterval(()=>{
            let now = new Date().getTime();
            let distance = countDownDate - now;
            let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);
            this.otp_time = ((minutes < 10) ? '0' + minutes : minutes) + ":" + ((seconds < 10) ? '0' + seconds : seconds);
            this.setState({ timeOut: this.otp_time });
            //console.log('time', this.otp_time)
            if (distance < 0 || this.otp_time === '00:00') {
                this.clearTimeOut();
            }
        }, 1000)
    }
    
    clearTimeOut() {
        clearInterval(this.timeOut);
        this.props.onSelectPage(1);
        console.log("TimeOut");
    }

    componentWillUnmount() {
        clearInterval(this.timeOut);
        console.log("Exit OTP TimeOut");
    }

    Submit = () => {
        if ( this.state.otp.length !== 6 ) {
            _Alert('กรุณากรอกเลข OTP ให้ครบ 6 หลัก');
            return;
        }

        this.setState({ loadingShow: true });

        var param = { account_id: this.props.AccountID, OTP: this.state.otp, via: 'website' };
        _post('check.OTP.php', param).then(res => { 
            this.setState({ loadingShow: false });
            if ( res.data.status ) {
                this.props.onSelectPage(3);
            } else {
                _Alert('modify', 'error', 'พบข้อผิดพลาด', res.data.responseText);
            }
        }).catch(err => { 
            this.setState({ loadingShow: false });
            _Alert('error'); 
        });

    }

    render() {
        return (
            <div>
                <Loading show={this.state.loadingShow} />
                <div className="register-row">
                    <div className="otp-title">กรุณาป้อนรหัส OTP ที่ได้รับจากมือถือของท่าน</div>
                </div>
                <div className="register-row">
                    <div className="otp-time">รหัส OTP จะหมดเวลาในอีก {this.state.timeOut}</div>
                </div>
                <div className="register-otp">
                    <div className="input-group mb-3 txt-input">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="basic-addon1"><i className="fas fa-unlock-alt"></i></span>
                        </div>
                        <InputMask className="form-control" mask="999999" maskChar={null} placeholder="รหัส OTP" value={this.state.otp} onChange={(e) => this.update("otp", e)} />
                    </div>
                </div>
                <div className="register-row btn-row">
                    <button type="button" className="btn btn-light btn-lg" onClick={(e) => this.Submit()}>ส่ง OTP</button>
                </div>
            </div>
        )
    }
}

export default RegisterOTP;